/* eslint-disable @typescript-eslint/triple-slash-reference */
/// <reference path="../../types/global.d.ts" />
import { BUITheme } from "@blofin/blofin-ui";
import { FC, lazy, useEffect } from "react";
import { createFooter } from "../Footer/entry";
import useNav from "./useNav";
import { footerName } from "@/nav-localized/config";

const DevFooter = lazy(() => import("../Footer"));

const NavFooter: FC<{
  theme: BUITheme;
  apiConfig: { baseUrl: string };
  locale?: string;
  footerBgColor?: string;
  isSimple?: boolean;
  size?: "1280" | "1440";
}> = ({ theme, apiConfig, locale, footerBgColor, isSimple = false, size }) => {
  const { sdkUrl, initFooter } = useNav();

  const footerConfig = {
    theme: theme,
    baseUrl: apiConfig.baseUrl,
    locale,
    footerBgColor: footerBgColor,
    isSimple: isSimple,
    size
  };

  const initFooterCallback = () => {
    const remoteFooter = (window as unknown as Record<string, unknown>)[footerName] as
      | { createFooter?: (config: typeof footerConfig & { env: string }) => void }
      | undefined;
    const createFooterRemote = remoteFooter?.createFooter;
    if (typeof createFooterRemote !== "function") {
      console.error(
        `[blofin-nav] ${footerName}.createFooter is not available — check nav UMD / entry.js`
      );
      return;
    }
    createFooterRemote({ ...footerConfig, env: "client" });
  };

  useEffect(() => {
    if (sdkUrl.footer) {
      initFooter(initFooterCallback);
    } else {
      if (process.env.NODE_ENV === "development") {
        createFooter(footerConfig);
      }
    }
  }, [sdkUrl.footer, theme, locale]);

  return (
    <div className={footerName} id="footer">
      <DevFooter
        theme={theme}
        baseUrl={apiConfig.baseUrl}
        locale={locale}
        footerBgColor={footerBgColor}
        isSimple={isSimple}
        size={size}
      />
    </div>
  );
};

export default NavFooter;
